import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { twMerge } from 'tailwind-merge'
import { FiTrash, FiShoppingCart } from 'react-icons/fi'

import { useClickOutside } from '../../hooks/useClickOutside'
import masks from '../../util/masks'

export default function ({ dropdownClassNames = '' }) {
	const cartDropdownRef = useRef()
	const triggerRef = useRef()

	const [item, setItem] = useState(null)
	const [isDropdownVisible, setIsDropdownVisible] = useState(false)

	useEffect(() => {
		const cartItemString = localStorage.getItem('sigas:carrinho')

		const data = cartItemString ? JSON.parse(cartItemString) : null

		setItem(data)
	}, [])

	useClickOutside({
		onClickOutside: () => { 
			setIsDropdownVisible(false)
		},
		dropdownRef: cartDropdownRef,
		triggerRef: triggerRef
	})

	function handleClearCart() {
		localStorage.removeItem('sigas:carrinho')
		
		setItem(null)
	}

	return (
		<>
			<div 
				className="group p-4 rounded-md cursor-pointer hover:opacity-80 relative w-14 select-none"
				onClick={() => { setIsDropdownVisible(true) }}
				ref={cartDropdownRef}
			>
				<FiShoppingCart size={22} className="text-slate-800 group-hover:scale-105 w-6 h-6 sm:w-5 sm:h-5" />
				{item && <span className="bg-sky-500 text-xs flex justify-center items-center rounded-full absolute w-4 h-4 font-bold bottom-3 right-2">1</span>}
			</div>

			<div 
				ref={triggerRef}
				className={twMerge(
					classNames(
						'z-20 top-0 right-0 w-screen',
						'p-3 rounded-md bg-white shadow-lg md:w-96 hidden absolute md:top-20 md:right-16 text-slate-800 animated fadeIn faster',
						{ 'flex flex-col gap-3': isDropdownVisible }
					),
					dropdownClassNames
				)}
			>
				{!!item ? (
					<>
						<h3 className="font-bold text-lg text-slate-800 px-4 md:px-0">Meu carrinho</h3>

						<ul>
							<li className="grid grid-cols-[1fr_80px_24px] items-center gap-3 px-4 md:px-0">
								<span>{`${item.modulo.descricao} - ${item.descricao} ${item.id === 1 ? 'GRATUITO' : item.periodo}`}</span>

								<span className="text-right">{masks.maskApply.currency(item.valor / 100)}</span>
								
								<FiTrash 
									onClick={handleClearCart} 
									size={20}
									className="text-red-600 hover:opacity-80 cursor-pointer justify-self-end hidden md:block" 
								/>

								<FiTrash 
									onClick={handleClearCart} 
									size={28}
									className="text-red-600 hover:opacity-80 cursor-pointer justify-self-end md:hidden" 
								/>
							</li>
						</ul>

						<hr className="" />

						<div className="flex justify-between items-center gap-8 px-4 md:px-0">
							<span className="font-semibold">TOTAL</span>
							<span>{masks.maskApply.currency(item.valor / 100)}</span>
						</div>
					</>
				) : (
					<div className="flex flex-col items-center gap-2 px-4 md:px-0">
						<FiShoppingCart size={32} className="text-slate-400" />
						
						<span className="italic text-center text-slate-400">Carrinho vazio</span>
					</div>
				)}
			</div>
		</>
	)
}
